import globalAxios from 'axios';
import { createRequestFunction, assertParamExists, DUMMY_BASE_URL, setSearchParams, toPathString, setApiKeyToObject } from '../common.mjs';
import { BASE_PATH, BaseAPI } from '../base.mjs';
import { makeRemoteWithOpenapiGenerator } from '@flex-packages/remote-core';

const JobDescriptionSupportPublicControllerApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * 
     * @param {JobDescriptionSupportPublicControllerApiGetEmploymentContractTypesInUsedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getEmploymentContractTypesInUsed: ({ customerIdHash }, options = {}) => {
      assertParamExists("getEmploymentContractTypesInUsed", "customerIdHash", customerIdHash);
      const localVarPath = `/api-public/v2/recruiting/customers/{customerIdHash}/employment-contract-types-in-used`.replace(`{${"customerIdHash"}}`, encodeURIComponent(String(customerIdHash)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setApiKeyToObject(localVarHeaderParameter, "x-flex-aid", configuration);
      setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      return {
        ...localVarRequestOptions,
        identifier: "getEmploymentContractTypesInUsed",
        url: toPathString(localVarUrlObj)
      };
    },
    /**
     * 
     * @summary 직무 조회 API
     * @param {JobDescriptionSupportPublicControllerApiGetJobRolesForPublicRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getJobRolesForPublic: ({ customerIdHash }, options = {}) => {
      assertParamExists("getJobRolesForPublic", "customerIdHash", customerIdHash);
      const localVarPath = `/api-public/v2/recruiting/customers/{customerIdHash}/job-roles`.replace(`{${"customerIdHash"}}`, encodeURIComponent(String(customerIdHash)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setApiKeyToObject(localVarHeaderParameter, "x-flex-aid", configuration);
      setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      return {
        ...localVarRequestOptions,
        identifier: "getJobRolesForPublic",
        url: toPathString(localVarUrlObj)
      };
    }
  };
};
const JobDescriptionSupportPublicControllerApiFp = function(configuration) {
  const localVarAxiosParamCreator = JobDescriptionSupportPublicControllerApiAxiosParamCreator(configuration);
  return {
    /**
     * 
     * @param {JobDescriptionSupportPublicControllerApiGetEmploymentContractTypesInUsedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getEmploymentContractTypesInUsed(requestParameters, options) {
      const localVarAxiosArgs = localVarAxiosParamCreator.getEmploymentContractTypesInUsed(requestParameters, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH);
    },
    /**
     * 
     * @summary 직무 조회 API
     * @param {JobDescriptionSupportPublicControllerApiGetJobRolesForPublicRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getJobRolesForPublic(requestParameters, options) {
      const localVarAxiosArgs = localVarAxiosParamCreator.getJobRolesForPublic(requestParameters, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH);
    }
  };
};
const JobDescriptionSupportPublicControllerApiFactory = function(configuration, basePath, axios) {
  const localVarFp = JobDescriptionSupportPublicControllerApiFp(configuration);
  return {
    /**
     * 
     * @param {JobDescriptionSupportPublicControllerApiGetEmploymentContractTypesInUsedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getEmploymentContractTypesInUsed(requestParameters, options) {
      return localVarFp.getEmploymentContractTypesInUsed(requestParameters, options)(axios, basePath);
    },
    /**
     * 
     * @summary 직무 조회 API
     * @param {JobDescriptionSupportPublicControllerApiGetJobRolesForPublicRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getJobRolesForPublic(requestParameters, options) {
      return localVarFp.getJobRolesForPublic(requestParameters, options)(axios, basePath);
    }
  };
};
class JobDescriptionSupportPublicControllerApi extends BaseAPI {
  /**
   * 
   * @param {JobDescriptionSupportPublicControllerApiGetEmploymentContractTypesInUsedRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof JobDescriptionSupportPublicControllerApi
   */
  getEmploymentContractTypesInUsed(requestParameters, options) {
    return JobDescriptionSupportPublicControllerApiFp(this.configuration).getEmploymentContractTypesInUsed(requestParameters, options)(this.axios, this.basePath);
  }
  /**
   * 
   * @summary 직무 조회 API
   * @param {JobDescriptionSupportPublicControllerApiGetJobRolesForPublicRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof JobDescriptionSupportPublicControllerApi
   */
  getJobRolesForPublic(requestParameters, options) {
    return JobDescriptionSupportPublicControllerApiFp(this.configuration).getJobRolesForPublic(requestParameters, options)(this.axios, this.basePath);
  }
}
const getEmploymentContractTypesInUsedRemote = makeRemoteWithOpenapiGenerator({
  requestArgsCreator: JobDescriptionSupportPublicControllerApiAxiosParamCreator().getEmploymentContractTypesInUsed,
  requestFn: JobDescriptionSupportPublicControllerApiFp().getEmploymentContractTypesInUsed
});
const getJobRolesForPublicRemote = makeRemoteWithOpenapiGenerator({
  requestArgsCreator: JobDescriptionSupportPublicControllerApiAxiosParamCreator().getJobRolesForPublic,
  requestFn: JobDescriptionSupportPublicControllerApiFp().getJobRolesForPublic
});

export { JobDescriptionSupportPublicControllerApi, JobDescriptionSupportPublicControllerApiAxiosParamCreator, JobDescriptionSupportPublicControllerApiFactory, JobDescriptionSupportPublicControllerApiFp, getEmploymentContractTypesInUsedRemote, getJobRolesForPublicRemote };
//# sourceMappingURL=job-description-support-public-controller-api.mjs.map
